import { render, staticRenderFns } from "./RegistrarProductoVenta.vue?vue&type=template&id=e35e2934&scoped=true&"
import script from "./RegistrarProductoVenta.vue?vue&type=script&lang=js&"
export * from "./RegistrarProductoVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35e2934",
  null
  
)

export default component.exports